<template>
  <div class="home">
    <div id="nav">
      <router-link to="/user">User</router-link> |
      <router-link to="/service">Service</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home'
}
</script>
